module.exports = __webpack_public_path__ + "static/media/relaxed-unicorn.27badfeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/relaxed-unicorn.png
// module id = 584
// module chunks = 0